export class AutoChargeThreshold{
    constructor(
        public isCapable:boolean,
        public isEnabled:boolean,
        public isClipOngoing:boolean,
        public endTime:Date
    ){}
}